// Mock data for Insectis Sàrl website

export const companyInfo = {
  name: "Insectis Sàrl",
  slogan: "Le nettoyage intelligent des coques de bateaux.",
  tagline: "Expert en nettoyage de coques par drone sous-marin",
  description: "Service professionnel de nettoyage de coques de bateaux avec drone sous-marin Keelcrab Pro",
  email: "info@desinfection.ch",
  phone: "+41 21 552 10 20",
  technology: "Keelcrab Pro"
};

export const offices = [
  {
    id: 1,
    sector: "Secteur Nyon & région",
    address: "Rue de la Gare 1",
    city: "1260 Nyon",
    phone: "021 552 10 20",
    email: "info@desinfection.ch",
    lake: "Lac Léman"
  },
  {
    id: 2,
    sector: "Secteur Estavayer-le-Lac & région",
    address: "Route du Yau 5",
    city: "1470 Lully",
    phone: "026 552 06 22",
    email: "info@desinfection.ch",
    lake: "Lac de Neuchâtel"
  },
  {
    id: 3,
    sector: "Secteur Morat & région",
    address: "Grausacher 1",
    city: "3213 Liebistorf",
    phone: "026 552 06 20",
    email: "info@desinfection.ch",
    lake: "Lac de Morat"
  }
];

export const services = [
  {
    id: 1,
    title: "Intervention sur tous types de bateaux",
    description: "Nous intervenons sur voiliers, yachts, vedettes et bateaux à moteur de toutes tailles."
  },
  {
    id: 2,
    title: "Économie de carburant 20-30%",
    description: "Une coque propre réduit significativement la consommation de carburant et les émissions CO2."
  },
  {
    id: 3,
    title: "Performance optimisée",
    description: "Gagnez en vitesse à la voile grâce à une glisse parfaite."
  },
  {
    id: 4,
    title: "Sans mise au sec",
    description: "Préservez votre antifouling, carénez moins souvent grâce à notre intervention à flot."
  },
  {
    id: 5,
    title: "Inspection vidéo incluse",
    description: "Lavage de la coque à flot avec inspection et enregistrement vidéo HD."
  },
  {
    id: 6,
    title: "Technologie écologique",
    description: "Nettoyage par robot sans utilisation d'eau ni produits chimiques nocifs."
  }
];

export const processSteps = [
  {
    id: 1,
    number: "01",
    title: "Demande de devis",
    description: "Contactez-nous pour obtenir un devis personnalisé et gratuit."
  },
  {
    id: 2,
    number: "02",
    title: "Planification",
    description: "Nous convenons ensemble d'une date d'intervention."
  },
  {
    id: 3,
    number: "03",
    title: "Intervention",
    description: "Notre drone Keelcrab Pro nettoie votre coque en quelques heures."
  },
  {
    id: 4,
    number: "04",
    title: "Rapport vidéo",
    description: "Recevez la vidéo HD de l'inspection de votre coque."
  }
];

export const advantages = [
  {
    id: 1,
    title: "Rapidité d'intervention",
    description: "Nettoyage réalisé en quelques heures, minimisant votre temps d'immobilisation.",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Résultat impeccable",
    description: "Élimination de plus de 95% de l'encrassement biologique sans mise au sec.",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Respect de l'environnement",
    description: "Filtre 160 microns retenant tous les déchets, aucun rejet dans le lac.",
    icon: "Leaf"
  },
  {
    id: 4,
    title: "Caméra embarquée",
    description: "Inspection vidéo en temps réel et enregistrement fourni après intervention.",
    icon: "Camera"
  }
];

export const lakes = [
  {
    id: 1,
    name: "Lac Léman",
    description: "Zone Nyon et environs"
  },
  {
    id: 2,
    name: "Lac de Neuchâtel",
    description: "Zone Estavayer-le-Lac"
  },
  {
    id: 3,
    name: "Lac de Morat",
    description: "Zone Morat et environs"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Pierre Müller",
    boat: "Voilier Bavaria 38",
    comment: "Service impeccable ! Mon bateau glisse comme jamais sur le Léman. Je recommande vivement Insectis pour l'entretien de coque.",
    rating: 5
  },
  {
    id: 2,
    name: "Marie Schneider",
    boat: "Vedette Quicksilver 755",
    comment: "Intervention rapide et professionnelle. La vidéo de l'inspection m'a permis de voir l'état réel de ma coque. Excellent !",
    rating: 5
  },
  {
    id: 3,
    name: "Jean-Marc Dubois",
    boat: "Yacht Jeanneau 42",
    comment: "Économie de carburant remarquable après le nettoyage. Le drone Keelcrab est vraiment une technologie révolutionnaire.",
    rating: 5
  }
];

export const openingHours = [
  { day: "Lundi", hours: "8h – 18h" },
  { day: "Mardi", hours: "8h – 18h" },
  { day: "Mercredi", hours: "8h – 18h" },
  { day: "Jeudi", hours: "8h – 18h" },
  { day: "Vendredi", hours: "8h – 18h" },
  { day: "Samedi", hours: "9h – 17h" },
  { day: "Dimanche", hours: "Fermé" }
];

export const stats = [
  { value: "500+", label: "Clients satisfaits" },
  { value: "2000+", label: "Nettoyages réalisés" },
  { value: "3", label: "Lacs couverts" }
];

export const videoUrl = "https://www.youtube.com/embed/PwO5jUTyE9Y";

export const droneImage = "https://customer-assets.emergentagent.com/job_e5574598-9882-4c0d-a82a-daa0265bfbb4/artifacts/zvjjecqk_Screenshot_20260102_213310_Chrome.jpg";
